import { createSlice } from "@reduxjs/toolkit";

const detallesautState = {
  detallesautdata: [],
};

const detallesautSlice = createSlice({
  name: "detallesaut",
  initialState: detallesautState,
  reducers: {
    DetallesAutData: (state, actions) => actions.payload,
  },
});

export const { DetallesAutData } = detallesautSlice.actions;

export default detallesautSlice.reducer;